module.exports = __webpack_public_path__ + "static/media/arrow-rigth-green.28125e94.svg";